jQuery(function() {
  jQuery(".testimonial-carousel").owlCarousel({
    navigation: true,
    navigationText: ["<i class='fa fa-angle-left'></i>", "<i class='fa fa-angle-right'></i>"],
    pagination: true,
    slideSpeed: 300,
    paginationSpeed: 400,
    singleItem: true,
  });
  
  jQuery('.colorbox').not('.youtube').not('.delay').colorbox({
    html : "<img src='' id='colorbox-image' class='img-responsive'/>",
    maxWidth: '80%',
    closeButton: false,
    maxHeight: '90%',
    innerWidth: function() {
      return jQuery(window).width() - 80; 
    },
    innerHeight: '100%',
    scrolling: false,
    onComplete : function() {     
      jQuery('#colorbox-image').attr('src', jQuery(this).attr('href'));
      jQuery.colorbox.resize();
    }
  });
  
  jQuery('.colorbox.delay').click(function() {
    var href = jQuery(this).attr('href');
    
    colorboxDelay = setTimeout(function() {
      jQuery.colorbox({
        html : "<img src='' id='colorbox-image' class='img-responsive'/>",
        maxWidth: '80%',
        closeButton: false,
        maxHeight: '90%',
        innerWidth: function() {
          return jQuery(window).width() - 80;
        },
        innerHeight: '100%',
        scrolling: false,
        onComplete : function() {     
          jQuery('#colorbox-image').attr('src', href);
          jQuery.colorbox.resize();
        }
      })
      .open();
    }, 200);
  });
  
  jQuery('#download-free-guide').colorbox({
    html : jQuery('#templates #watercolor-guide').html(),
    maxWidth: '80%',
    closeButton: false,
    maxHeight: '90%',
    innerWidth: function() {
      return jQuery(window).width() - 80;
    },
    innerHeight: '100%',
    scrolling: false,
    onComplete : function() {     
      jQuery.colorbox.resize();
    }
  });
  
  jQuery(window).resize(function() {
    jQuery.colorbox.resize({
      width: '80%',
    })
  });  
  
  setupColorBoxYoutubeVideos();
  setupProductPage(); 
  setupDealerPage();
  setupResourcePage();
  setupAboutUsPage();
  setupBlogPage();
  fixInfusionForm();
  setupWarrantyPage(); 
});
var colorboxDelay = null;
 
function fixInfusionForm() {
  jQuery('.infusion-form input[type=text]').addClass('form-control');
  jQuery('.infusion-form .infusion-field').addClass('form-group');
  
  jQuery('.infusion-form textarea').addClass('form-control');
  jQuery('.infusion-form select').addClass('form-control');
  jQuery('.infusion-form #submit').addClass('btn btn-default btn-primary pull-right');
  jQuery('.infusion-form table').addClass('table');
  jQuery('.infusion-form table tr td ').css('border','none');
  
  jQuery('.infusion-form .infusion-field').each(function(index) {    
    if (jQuery(this).html().indexOf('*') > -1)
      jQuery(this).find('input, select').attr('required', 'required');
  });  
  
  jQuery('.infusion-form table tr td p').each(function(index) {    
    if (jQuery(this).css('color')) {
      if (jQuery(this).css('color') == 'rgb(0, 0, 139)') {
        jQuery(this).addClass('h2 margin-bottom-none margin-top-none');
        
        if (jQuery(this).parent().attr('colspan') != 2) {
          jQuery(this).parent().next('td').remove();
          jQuery(this).parent().attr('colspan', '2');
        }
      }
    }
    
    if (jQuery(this).html().indexOf('*') > -1)
      jQuery(this).parent().next('td').find('input, select').attr('required', 'required');
  });
  
  jQuery('.infusion-form table tr td p').attr('style','');
  
  jQuery('.infusion-form table tr td span').each(function(index) {
      jQuery(this).parent().find('input').attr('placeholder', jQuery(this).html().trim());
      jQuery(this).remove();
  });
  
  jQuery( ".infusion-form input[placeholder='(date format: MM-DD-YYYY)']" ).datepicker({
    'dateFormat' : 'mm-dd-yy'
  });
}
 
function setupColorBoxYoutubeVideos() {
  jQuery('a.colorbox.youtube').colorbox({
    html : "<div class='embed-responsive embed-responsive-16by9'><iframe id='colorbox-youtube' class='embed-responsive-item' src='' frameborder='0' allowfullscreen></iframe></div>",
    maxWidth: '80%',
    maxHeight: '90%',
    closeButton: false,
    width: '90%',
    onComplete : function() {     
      jQuery('#colorbox-youtube').attr('src','https://www.youtube.com/embed/' + jQuery(this).attr('embeded-code') + '?rel=0');
      jQuery.colorbox.resize();
    }
  }); 
}

function checkIfImageExists(imageId, placeholderSize) {
  var imageSelector = '#' + imageId;
  
  if (imageId.indexOf('.') >= 0)
    imageSelector = imageId;
  
  jQuery(imageSelector).each(function (index) {
    var img = jQuery(this);    
    jQuery.get(img.attr('src'), null 
      , function(data) {
      
      }).fail(function(XMLHttpRequest, textStatus, errorThrown) {
        img.attr('src', 'http://placehold.it/' + placeholderSize);
    });  
  });  
}